import React, { ReactNode } from 'react';
import classNames from 'classnames';

import TableBody from '../TableBody';
import Loading from '../component/Loading';
import { CheckType, Column, Row } from '../component/types';

import TableHeadView from './TableHeadView';
import RowView from './RowView';

interface Props<T> {
  height?: number;
  isBorder?: boolean;
  tableType?: 'primary' | 'danger' | 'success' | 'warning' | 'info';
  trColor?: string;
  isStickyHeader?: boolean;
  check?: CheckType;
  columns: Column<T>[];
  rows: T[];
  loading?: boolean;
  loadingItemCount?: number;
  children?: ReactNode;
  isShowColumnHeader?: boolean;
  loadingHeight?: string;
  activePage: number;
  isFixedColumn?: boolean;
  isHideYOverflow?: boolean;
}

function TableView<T extends Row>({
  height,
  isBorder,
  tableType,
  trColor,
  isStickyHeader,
  check,
  rows,
  columns,
  loading,
  loadingItemCount,
  children,
  isShowColumnHeader,
  activePage,
  loadingHeight,
  isFixedColumn,
  isHideYOverflow = true,
}: Props<T>) {
  return (
    <div
      className={classNames('overflow-x-auto', {
        'overflow-y-auto': height,
        'overflow-y-hidden': isHideYOverflow,
        'scrollbar-hidden': !isHideYOverflow,
        'position-relative': isFixedColumn,
      })}
      style={height && { height: `${height}px` }}
    >
      <table
        className={classNames('table', {
          'table-border': isBorder,
          [`table-${tableType}`]: tableType,
        })}
      >
        <TableHeadView<T>
          check={check}
          columns={columns}
          isShowColumnHeader={isShowColumnHeader}
          isStickyHeader={isStickyHeader}
          activePage={activePage}
        />

        <TableBody>
          {!loading
            ? rows?.map((row, index) => (
                <RowView<T>
                  key={row?.id || index}
                  row={row}
                  index={index}
                  columns={columns}
                  trColor={trColor}
                  check={check}
                />
              ))
            : null}

          {children}

          {loading ? (
            <Loading
              columns={columns}
              height={loadingHeight}
              loadingItemCount={loadingItemCount}
            />
          ) : null}
        </TableBody>
      </table>
    </div>
  );
}

export default TableView;
